/* Tab switching and colour swatches for the brand picks sections.
 *
 * Was inline in the section, scoped via document.currentScript.closest(). That
 * cannot work from an external file, and with seven instances on the homepage
 * the inline copy shipped seven times. Scope per root element instead, and
 * re-init on shopify:section:load so the theme editor stays live.
 */
(function () {
  function initRoot(root) {
    if (root.dataset.epInit) return;
    root.dataset.epInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.ep-tab'));

    function select(tab) {
      var idx = tab.getAttribute('data-ep-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        // Roving tabindex: only the active tab is in the tab order.
        t.tabIndex = on ? 0 : -1;
      });
      root.querySelectorAll('[data-ep-panel]').forEach(function (panel) {
        var show = panel.getAttribute('data-ep-panel') === idx;
        panel.classList.toggle('is-hidden', !show);
        if (show) {
          panel.style.opacity = 0;
          requestAnimationFrame(function () { panel.style.opacity = 1; });
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      // Arrow keys are expected on a role="tablist" and were missing entirely.
      tab.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });

    root.querySelectorAll('.ep-card').forEach(function (card) {
      card.querySelectorAll('.ep-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          card.querySelectorAll('.ep-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');
          var img = card.querySelector('.ep-card__img');
          var src = swatch.getAttribute('data-ep-image');
          if (img && src) {
            // srcset would otherwise win over the new src.
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = src;
          }
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.vantage-essential-picks').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
